/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * @export
 */
export const RestrictionCheckItemDTOStatusEnum = {
    Pending: 'PENDING',
    InProgress: 'IN_PROGRESS',
    Done: 'DONE',
    Error: 'ERROR',
    Cancelled: 'CANCELLED'
};
/**
 * @export
 */
export const RestrictionCheckItemDTOOutcomeEnum = {
    Unrestricted: 'UNRESTRICTED',
    ApprovalRequired: 'APPROVAL_REQUIRED',
    NotEligible: 'NOT_ELIGIBLE',
    NotFound: 'NOT_FOUND',
    Error: 'ERROR'
};
/**
 * Check if a given object implements the RestrictionCheckItemDTO interface.
 */
export function instanceOfRestrictionCheckItemDTO(value) {
    return true;
}
export function RestrictionCheckItemDTOFromJSON(json) {
    return RestrictionCheckItemDTOFromJSONTyped(json, false);
}
export function RestrictionCheckItemDTOFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'] == null ? undefined : json['id'],
        'asin': json['asin'] == null ? undefined : json['asin'],
        'status': json['status'] == null ? undefined : json['status'],
        'outcome': json['outcome'] == null ? undefined : json['outcome'],
        'reasonCodes': json['reasonCodes'] == null ? undefined : json['reasonCodes'],
        'message': json['message'] == null ? undefined : json['message'],
        'approvalLink': json['approvalLink'] == null ? undefined : json['approvalLink'],
    };
}
export function RestrictionCheckItemDTOToJSON(json) {
    return RestrictionCheckItemDTOToJSONTyped(json, false);
}
export function RestrictionCheckItemDTOToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'asin': value['asin'],
        'status': value['status'],
        'outcome': value['outcome'],
        'reasonCodes': value['reasonCodes'],
        'message': value['message'],
        'approvalLink': value['approvalLink'],
    };
}
